export const SET_THEME = 'APP_CONFIG__SET_THEME';
export const SET_BACK_BUTTON = 'APP_CONFIG__SET_BACK_BUTTON';
export const SET_DEVICE = 'SET_DEVICE';

export type SetThemeType = typeof SET_THEME;
export type SetBackButtonType = typeof SET_BACK_BUTTON;
export type SetDevice = typeof SET_DEVICE;

export enum Themes {
    DARK = 'DARK',
    LIGHT = 'LIGHT',
}
